export default __webpack_public_path__ + "static/media/Quill of Ibis.5f077119.jpg";